import { SvgIcon } from '../SvgIcon';
import { THEME } from '../../../../components-v2/Theme/theme';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
	ringColor?: string;
	size?: number;
}

const initialSize = 20;

export const SuccessCheckIcon: React.FC<IProps> = props => {
	const { className, fillColor, size, ringColor } = props;
	const finalSize = size ?? initialSize;
	return (
		<SvgIcon
			className={`success-check-icon ${className || ''}`}
			height={finalSize}
			width={finalSize}
			viewBox={`0 0 ${initialSize} ${initialSize}`}
			role='img'
			aria-label='Success check'
			data-testid='success-check-icon'
		>
			<g fill='none' fillRule='evenodd'>
				<circle cx='10' cy='10' r='10' fill={fillColor || THEME.colors.success.main} />
				<circle cx='10' cy='10' r='9' stroke={ringColor || THEME.colors.success.light} strokeWidth='2' />
				<polygon fill='white' points='9.16 14.927 5.116 10.884 6.884 9.116 8.841 11.073 12.983 5.274 15.017 6.726' />
			</g>
		</SvgIcon>
	);
};
